<template>
    <div>
        <div class="alert-cancel-status mb-4" v-if="order_status == 'cancel'">
            <div class=" tw-flex tw-flex-col">
                <div class="tw-flex tw-justify-center">
                    <i class="fa fa-exclamation-triangle tw-text-red-400 tw-text-5xl" aria-hidden="true"></i>
                </div>
                <div>
                    <p class="tw-flex tw-items-center tw-text-red-400 mb-1">หมายเลขคำสั่งซื้อสินค้า #{{order.reference}} ถูกยกเลิก</p>
                </div>
                <div class="tw-flex tw-items-center tw-text-red-400">
                    <p>**หมายเหตุ: <span class="tw-underline tw-underline-offset-4">{{order.reason_cancel}}</span></p>
                </div>
            </div>

        </div>
        <div class="process-wrap active-step1" v-if="order_status != 'cancel'">
            <div class="tw-flex tw-self-center tw-justify-center tw-w-full process-current-label">
                <div class="">
                    <span v-if="order_status == 'pending'">รอการตรวจสอบการชำระเงิน</span>
                    <span v-else-if="order_status == 'approved'">กำลังเตรียมจัดส่ง</span>
                    <span v-else-if="order_status == 'done'">จัดส่งแล้ว</span>
                    <span v-else></span>
                </div>
            </div>
            <div class="process-main">
                <div class="col-3">
                    <div class="process-step-cont">
                        <div class="process-step step-1"></div>
                            <span class="process-label">ตรวจสอบการชำระเงิน</span>
                            <div class="process-dot-cont">
                            <div class="process-dots ship-process-dot-1"></div>
                            <div class="process-dots ship-process-dot-2"></div>
                            <div class="process-dots ship-process-dot-3"></div>
                        </div>
                    </div>
                </div>
                <div class="col-3">
                    <div class="process-step-cont">
                        <div class="process-step step-2"></div>
                        <span class="process-label">กำลังเตรียมจัดส่ง</span>
                    </div>
                </div>
                <div class="col-3">
                    <div class="process-step-cont">
                        <div class="process-step step-3"></div>
                        <span class="process-label">จัดส่งแล้ว</span>
                    </div>
                </div>
            </div>
        </div>
    </div>    
</template>

<style scoped>
.alert-cancel-status {
    width: 100%;
    min-width: 320px;
    display: flex;
    justify-content: center;
}
.process-wrap {
  width: 100%;
  margin: 50px 0;
  pointer-events: none;
}
.process-main {
    width: 100%;
    min-width: 320px;
    display: flex;
    justify-content: center;
}
.col-3 {
  width: 25%;
  position: relative;
}
.col-3:first-child .process-step:before {
    content: '1';
}
.col-3:nth-child(2) .process-step:before{
    content: '2';
}
.col-3:nth-child(3) .process-step:before {
    content: '3';
}
.process-main .col-3:not(:first-child):before{
    content: "";
    display: block;
    position: absolute;
    width: 100%;
    height: 4px;
    top: 17.5px;
    left: calc(-50% + 17px);
    right: 0;
    background: #ebebeb;
   -o-transition: .4s;
    -ms-transition: .4s;
    -moz-transition: .4s;
    -webkit-transition: .4s;
     transition: .4s;
}
.process-step-cont {
    font-family: sans-serif;
    font-size: 16px;
    text-transform: uppercase;
    text-decoration: none;
    white-space: nowrap;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    align-content: space-between;
}
.process-step {
    border: 5px #ebebeb solid;
    border-radius: 100%;
    line-height: 0;
    background: #959595;
    text-align: center;
    align-items: center;
    justify-content: center;
    align-self: center;
    display: flex;
    color: #fff;
    width: 35px;
    height: 35px;
    font-weight: 700;
    margin-bottom: 7px;
    z-index: 4;
    cursor: pointer;
}
.process-label {
    color: #959595;
    font-weight: 600;
     width: 100%;
     text-align: center;
}
.process-dots {
    width: 10px; 
    height: 10px;
    border-radius: 50%;
    background-color: #ebebeb;
    cursor: pointer;
}
.process-dot-cont {
    display: flex;
    justify-content: space-around;
    align-items: stretch;
    width: 60%; 
    padding-top: 5px;
}
.active-step1 .col-3:first-child .process-step,
.active-step1 .col-3:first-child .process-dots:first-child,
.active-step1-mini2 .col-3:first-child .process-step,
.active-step1-mini2 .col-3:first-child .process-dots:nth-child(-n+2),
.active-step1-mini3 .col-3:first-child .process-step,
.active-step1-mini3 .col-3:first-child .process-dots:nth-child(-n+3),
.active-step1-mini4 .col-3:first-child .process-step,
.active-step1-mini4 .col-3:first-child .process-dots:nth-child(-n+4)
{
    background-color: #f89828;
}
.active-step1-mini2 .col-3:first-child .process-dots:first-child,
.active-step1-mini3 .col-3:first-child .process-dots:nth-child(-n+2),
.active-step1-mini4 .col-3:first-child .process-dots:nth-child(-n+3)
 {
    background-color: #fbcb93;
}
.active-step1 .col-3:first-child .process-label,
.active-step1-mini3 .col-3:first-child .process-label,
.active-step1-mini2 .col-3:first-child .process-label,
.active-step1-mini4 .col-3:first-child .process-label{
    color: #f89828;
}
.active-step2 .col-3:first-child,
.active-step3 .col-3:nth-child(-n+2),
.active-step4 .col-3:nth-child(-n+3){
    opacity: 0.5;
   /* pointer-events: none; */
}
.active-step2 .col-3:first-child .process-step:before,
.active-step3 .col-3:nth-child(-n+2) .process-step:before,
.active-step4 .col-3:nth-child(-n+3) .process-step:before{
    content: '\2713';
    padding: 7px;
}
.active-step2 .col-3:nth-child(-n+2) .process-step,
.active-step2 .col-3:nth-child(-n+2) .process-dots,
.active-step3 .col-3:nth-child(-n+3) .process-step,
.active-step3 .col-3:nth-child(-n+3) .process-dots,
.active-step4 .col-3:nth-child(-n+4) .process-step,
.active-step4 .col-3:nth-child(-n+4) .process-dots {
    background-color: #f89828;
}
.active-step2 .col-3:nth-child(-n+2) .process-label,
.active-step3 .col-3:nth-child(-n+3) .process-label,
.active-step4 .col-3:nth-child(-n+4) .process-label{
    color: #f89828;
}
.active-step2 .col-3:nth-child(-n+2):before,
.active-step3 .col-3:nth-child(-n+3):before,
.active-step4 .col-3:nth-child(-n+4):before{
    background: #f89828 !important;
}
.process-current-label {
    visibility: hidden;
    color: #f89828;
    font-weight: 600;
     width: 100%;
     text-align: center;

}
@media screen and (max-width: 768px) {
    .process-label {
        visibility: hidden;
    }
    .process-dot-cont {
        visibility: hidden;
    }
    .process-current-label {
        visibility: visible;
    }

}
</style>

<script>
export default {
    props: ["status", "order"],
    data() {
        return {
            order_status: "",
        }
    },
    watch: {
        order_status: function(val) {
            switch (val) {
                case "pending":
                    $(".process-wrap").addClass("active-step1")
                    break;
                case "approve":
                    $(".process-wrap").attr('class', 'process-wrap');
                    $(this).parents(".process-wrap").addClass("active-step2")
                    $(".process-wrap").attr('class', 'process-wrap active-step2')
                    $(this).parents().find(".process-wrap").addClass("active-step1-mini2")
                    break;
                case "done":
                    $(".process-wrap").attr('class', 'process-wrap');
                    $(this).parents(".process-wrap").addClass("active-step3")
                    $(".process-wrap").attr('class', 'process-wrap active-step3')
                    $(this).parents().find(".process-wrap").addClass("active-step1-mini3")
                    break;
                default:
                    $(".process-wrap").attr('class', 'process-wrap');
            }

        }

    },
    mounted() {
        this.order_status = this.status;
    },
    
}
</script>